export default defineNuxtPlugin((nuxtApp) => {
  const i18n: any = nuxtApp.$i18n
  const originalT = i18n.t.bind(i18n)

  const keyExists = (key: string) => {
    try {
      return i18n.te(key)
    } catch {
      return false
    }
  }

  i18n.t = (key: string | string[], ...args: any[]) => {
    if (typeof key === 'string') {
      const variants = [key.replaceAll('/', '-'), key.replaceAll('/', '.'), key]

      const found = variants.find((k) => keyExists(k))
      key = found || variants[0]
    }

    return originalT(key, ...args)
  }
})
